import { Observable } from "rxjs";
import { ITokenPair } from "../../../features/auth/interface/dto/token-pair";
import { get } from "../../../service/api";
import { ChangeLogColumns } from "../enum/change-log-columns";
import { IChangeLogDto } from "../interface/dto/change-log.dto";

interface IFetchChangeLogsParams {
    limit?: number;
    offset?: number;
    query?: string;
    sortField?: ChangeLogColumns;
    sortDirection?: "asc" | "desc";
}

export const fetchChangeLogs = (
    params: IFetchChangeLogsParams,
    tokens: ITokenPair,
): Observable<IChangeLogDto> => {
    const queryParams = [
        params.limit !== undefined ? `limit=${params.limit}` : null,
        params.offset !== undefined ? `offset=${params.offset}` : null,
        params.query ? `query=${encodeURIComponent(params.query)}` : null,
        params.sortField
            ? `sortField=${encodeURIComponent(params.sortField)}`
            : null,
        params.sortDirection ? `sortDirection=${params.sortDirection}` : null,
    ]
        .filter(Boolean)
        .join("&");

    return get<IChangeLogDto>(`/change-logs?${queryParams}`, undefined, tokens);
};
